var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Watch, Utils, PropertyConverters, Components } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemImageElement = class PacemImageElement extends Components.PacemElement {
    constructor() {
        super('img');
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'src':
                case 'disabled':
                    this._setSource();
                    break;
                case 'size':
                case 'adapt':
                    this._setLayout();
                    break;
                case 'loading':
                    (!val ? Utils.addClass : Utils.removeClass)(this, 'img-ready');
                    break;
            }
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._setLayout();
        this._setSource();
    }
    _setLayout() {
        const sizeDeclared = !Utils.isNullOrEmpty(this.size);
        const bgsize = this.adapt || 'auto';
        const size = this.size || this.#naturalSize || { width: '0', height: '0' };
        this.style.backgroundSize = bgsize;
        const adapt = bgsize === 'auto', w = size.width, h = size.height;
        if (adapt || sizeDeclared) {
            this.style.width = w || '';
            this.style.height = h || '';
        }
    }
    #naturalSize;
    async _setSource() {
        if (this.disabled || !this.isReady) {
            return;
        }
        //
        const src = this.src;
        this.style.backgroundImage = '';
        if (!Utils.isNullOrEmpty(src)) {
            this.loading = true;
            try {
                const img = await Utils.loadImage(src);
                let weight, entries, entry;
                if (window.performance
                    && (entries = performance.getEntriesByName(img.src))
                    && (entry = entries[0])) {
                    weight = entry.decodedBodySize;
                }
                this.#naturalSize = {
                    width: img.naturalWidth + 'px',
                    height: img.naturalHeight + 'px',
                    weight: weight
                };
                this._setLayout();
                this.style.backgroundImage = `url("${img.src}")`;
            }
            catch (e) {
                // 404, whatever...
            }
            finally {
                this.loading = false;
            }
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemImageElement.prototype, "adapt", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemImageElement.prototype, "src", void 0);
__decorate([
    Watch({ emit: false,
        converter: {
            convert: (attr, el) => {
                // parse strings like "20,20" ".5 , 1vh" "15" and returns respectively ["20px", "20px"], [".5px", "1vh"] and ["15px", "15px"]
                const regex = /^\s*([\d.]+)(px|em|rem|vw|vh)?\s*(?:,\s*([\d.]+)(px|em|rem|vw|vh)?)?\s*$/i;
                const match = regex.exec(attr);
                const width = match ? match[1] + (match[2] || 'px') : '0', height = match ? (match[3] ? match[3] + (match[4] || 'px') : width) : '0';
                return { width, height };
            },
            convertBack: (prop, el) => `${prop?.width},${prop?.height}`
        }, reflectBack: true })
], PacemImageElement.prototype, "size", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemImageElement.prototype, "loading", void 0);
PacemImageElement = __decorate([
    CustomElement({
        tagName: P + '-img'
    })
], PacemImageElement);
export { PacemImageElement };
